import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';

import { CaoMetricCyclePerformance } from './cao-metric-cycle-performance.widget.model';
import { CaoOpportunityPopupMetric } from './cao-opportunity.widget.model';
import { TranslationKeyMap } from './legacy-widget.i18n';
import { LegacyWidgetService } from './legacy-widget.service';

@Component({
    selector: 'cmps-widget-cao-metric-cycle-performance',
    templateUrl: './cao-metric-cycle-performance.widget.component.html',
})
export class CaoMetricCyclePerformanceWidgetComponent implements OnChanges {
    @Input()
    metric: CaoOpportunityPopupMetric;

    i18n = TranslationKeyMap;
    hasPendingData: boolean;
    data: CaoMetricCyclePerformance;

    constructor(private readonly _service: LegacyWidgetService) {}

    ngOnChanges(changes: SimpleChanges): void {
        // eslint-disable-next-line @typescript-eslint/dot-notation
        const change = changes['metric'];
        // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
        if (change && change.currentValue) {
            this.hasPendingData = true;
            this._service
                .caoMetricCyclePerformance(this.metric.userId, this.metric.id)
                // eslint-disable-next-line no-return-assign
                .subscribe(
                    (data) => (this.data = data),
                    // eslint-disable-next-line n/handle-callback-err, no-return-assign
                    (error) => (this.hasPendingData = false),
                    // eslint-disable-next-line no-return-assign
                    () => (this.hasPendingData = false),
                );
        }
    }
}
